import { ProviderId } from 'firebase/auth'

export const AuthProviderId = {
  ...ProviderId,
  /** Apple provider ID */
  APPLE: 'apple.com',
}
